"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityListIteratorImpl = void 0;
const EntityPageListIterator_1 = require("./EntityPageListIterator");
const IteratorUtilFunctions_1 = require("./IteratorUtilFunctions");
class EntityListIteratorImpl {
    constructor(pageQueryFunc) {
        this._entityPages = new EntityPageListIterator_1.EntityPageListIterator(pageQueryFunc);
        this._entities = (0, IteratorUtilFunctions_1.flatten)(this._entityPages);
    }
    [Symbol.asyncIterator]() {
        return this;
    }
    async next() {
        return this._entities.next();
    }
    byPage() {
        return this._entityPages;
    }
}
exports.EntityListIteratorImpl = EntityListIteratorImpl;
//# sourceMappingURL=EntityListIteratorImpl.js.map